<app-header></app-header>
<app-banner></app-banner>

<div class="container services-section" style="margin: 3rem auto">
    <div class="row">
      <div class="col-lg-6 mb-3">
        <h1 style="color: #0e0e0e; font-size: 25px; font-weight: 700">
      Services
     </h1>
     <mat-label style="font-size: 22px; color: #00943a; font-weight: 400;">General Requirements for working permit:</mat-label>
     <div class="col-lg-12 mt-2">
      <mat-label class="general-requirements-label">Public Employment Services Office</mat-label>
      <ul class="card-requirement-list">
        <li class="requirement-items">
          FILLED OUT WORKING PERMIT APPLICATION FORM (NSRP FORM)
        </li>
        <li class="requirement-items">
          COMMUNITY TAX CERTIFICATE (CDC)/CEDULA
        </li>
        <li class="requirement-items">WORKING PERMIT FEE RECEIPT</li>
        <li class="requirement-items">POLICE CLEARANCE</li>
        <li class="requirement-items">MEDICAL TEST RESULTS</li>
        <li class="requirement-items">
          HEALTH CARD
        </li>
        <li class="requirement-items">
          CERTIFICATE OF FOOD HANDLER SEMINAR (FOR FOOD HANDLERS ONLY)
        </li>
        <li class="requirement-items">PARENT/GUARDIAN'S LETTER OF CONSENT FOR MINORS</li>
      </ul>
      
    </div>
    <div class="col-lg-12">
      <mat-label class="general-requirements-label">Health Services Office</mat-label>
      <ul class="card-requirement-list">
        <li class="requirement-items">
          FILLED OUT WORKING PERMIT APPLICATION FORM (NSRP FORM)
        </li>
        <li class="requirement-items">
          OFFICIAL RECEIPT OF PAYMENT FOR HEALTH CERTIFICATE, AND OTHER NECESSARY FEES
        </li>
        <li class="requirement-items">LABORATORY RESULTS</li>
        <li class="requirement-items">VALID ID (GOVERNMENT ISSUED)</li>
        <li class="requirement-items">
          ONE PIECE 1 X 1 ID PICTURE
        </li>
      </ul>
      
    </div>
    <div class="col-lg-12">
      <mat-label class="general-requirements-label">Baguio City Police Office</mat-label>
      <ul class="card-requirement-list">
        <li class="requirement-items">
          COMMUNITY TAX CERTIFICATE (CDC)/CEDULA
        </li>
        <li class="requirement-items">
          POLICE CLEARANCE PAYMENT RECEIPT
        </li>
        <li class="requirement-items">COURT CLEARANCE FOR APPLICANTS WITH HIT/RECORD</li>
      </ul>
    </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-12">
            <mat-accordion>
              <mat-expansion-panel expanded hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Non-Food Handler Working Permit
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-label class="label-requirents">Additional Requirements</mat-label>
                <ul class="card-requirement-list">
                  <li class="requirement-items">
                    Filled out Health Certificate Application Form
                  </li>
                  <li class="requirement-items">
                    Official receipt of payment for health certificate, and other
                    necessary fees
                  </li>
                  <li class="requirement-items">Laboratory results</li>
                  <li class="requirement-items">
                    Food handler's orientation/seminar certificate
                  </li>
                  <li class="requirement-items">Valid ID (Government Issued)</li>
                </ul>
              </mat-expansion-panel>
            </mat-accordion>
          </div> 
        </div>
      </div>
    </div>
  
    <div class="row">
      
      <div class="col-lg-4">
        
      </div>
    </div>
   
   </div>


<app-footer></app-footer>